import { render, staticRenderFns } from "./TrailerIdentifierForm.vue?vue&type=template&id=8d927c1a&"
import script from "./TrailerIdentifierForm.vue?vue&type=script&lang=js&"
export * from "./TrailerIdentifierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports